import { writable, get } from "svelte/store";
import axios, { getDbTarget, setDbTarget, resetDbTarget } from "../utiles/axios.util";

// SYS_CODE 별 화면 표시명 (REFRN_NM 이 retech / retech_test1 처럼 기술명이라 화면에는 쉽게 고정 표기)
export const DB_LABELS = { R: "운영", T: "테스트" };

// 접속 가능한 DB 목록 [{ code: "R", name: "운영서버", dbName: "ERPG_RETECH" }, ...]
export const dbTargets = writable([]);

// 현재 접속 DB 정보 (companyName = SYS_BPLC.BPLC_NM)
export const dbInfo = writable({ code: "R", companyName: "", dbName: "", loaded: false });

// 접속 가능한 DB 목록 조회 (SYS_REFRN_CODE / DB_INFO)
export async function loadDbTargets() {
    try {
        const res = await axios.get("dbTarget/list");
        const rows = res?.data?.code === 200 ? res.data.data || [] : [];
        dbTargets.set(
            rows.map((r) => ({
                code: String(r.sys_code || "").trim(),
                name: DB_LABELS[String(r.sys_code || "").trim()] || r.refrn_nm || r.sys_code,
                dbName: r.db_nm || "",
            })),
        );
    } catch (e) {
        console.error("DB 목록 조회 실패:", e);
    }
    return get(dbTargets);
}

// 현재 접속 DB 정보 조회. 성공 여부를 반환한다.
export async function loadDbInfo() {
    const code = await getDbTarget();
    try {
        const res = await axios.get("dbTarget/info");
        if (res?.data?.code === 200 && res.data.data) {
            const d = res.data.data;
            dbInfo.set({
                code: d.sys_code || code,
                companyName: d.bplc_nm || "",
                dbName: d.db_nm || "",
                loaded: true,
            });
            return true;
        }
    } catch (e) {
        console.error("접속 DB 정보 조회 실패:", e);
    }
    dbInfo.update((s) => ({ ...s, code, loaded: true }));
    return false;
}

// DB 전환: 선택값 저장 후 새로고침 (화면/캐시 데이터를 전부 새 DB 기준으로 다시 불러온다)
export async function switchDbTarget(code) {
    await setDbTarget(code);
    window.location.reload();
}

// 개발 DB 연결 실패 등으로 운영 DB 로 되돌릴 때
export async function revertToDefaultDb() {
    await resetDbTarget();
    window.location.reload();
}
